// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-4f8a1e54]{padding-top:.5rem;font-size:.53rem;font-weight:700;margin-bottom:.42rem}.desc[data-v-4f8a1e54]{font-size:.34rem;margin-bottom:.5rem}.step-bar-bg[data-v-4f8a1e54]{background:#f1f1f1;border-radius:.32rem;padding:.42rem;margin-bottom:.42rem}@media screen and (orientation:landscape){.btn-for-vertical[data-v-4f8a1e54]{width:60%;margin:0 auto;padding-left:.6rem;padding-right:.6rem;box-sizing:border-box}.title[data-v-4f8a1e54]{padding-top:0!important}}", ""]);
// Exports
module.exports = exports;
